"use client"
import "./App.css";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import HomePage from "./pages/Home";
import Services from "./pages/Services";
import { useEffect } from "react";
const MainPage = ({ homeRef, aboutRef, servicesRef, contactRef }) => {
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash) {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  return (
    <>
      <div ref={homeRef} id="home" className="w-full overflow-hidden">
        <HomePage />
      </div>

      {/* Image container positioned in the center of the elliptical shape */}
      <div className="custom-b-shape-container w-full relative overflow-visible">
        <div className="custom-b-shape w-full h-60 sm:h-70 md:h-80 bg-[#111d57]"></div>

        {/* Image positioned in the center */}
        <div className="image-container">
          <div className="bg-overlay"></div> {/* Optional overlay */}
          <div className="w-full mx-auto z-10 ">
            <img
              src="/centresc.png" 
              alt="Healthcare Hero"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>

      <div ref={aboutRef} id="about" className="mt-40 sm:mt-48 md:mt-56 lg:mt-64 w-full overflow-hidden">
        <AboutUs />
      </div>
      <div ref={servicesRef} id="services" className="w-full overflow-hidden">
        <Services />
      </div>
      <div ref={contactRef} id="contact" className="w-full overflow-hidden">
        <Contact 
        
        
        />
      </div>
    </>
  );
};

export default MainPage;
